import React, { useRef } from 'react';

import { useTranslation } from 'react-i18next';

import { ITabBarProps } from '../../../../interfaces/tabbars';
import ScrollZone from '../../Globals/ScrollZone/ScrollZone';
import './TabBar.scss';

const TabBar = ({ items, action, activeIndex, variant = 'primary' }: ITabBarProps) => {
  const tabsRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();

  const onSelect = (index: number, value: string) => {
    if (tabsRef.current) {
      const activeTab = tabsRef.current.children[index] as HTMLElement;
      activeTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
    action(index, value);
  };

  return (
    <div className="tab-bar-container">
      <div className="tab-bar-items flex flex-row gap-x-2" ref={tabsRef}>
        {items.map((item, index) => (
          <button
            key={`tab-item-${item}-${index}`}
            className={`tab-bar-item  ${variant} ${activeIndex === index ? 'active' : ''} flex flex-row gap-x-1 h-10`}
            onClick={() => onSelect(index, item.value)}
          >
            {item.icon && <item.icon.component />}
            <p className="tab-bar-text w-max">{t(item.value)}</p>
          </button>
        ))}
      </div>
      <ScrollZone containerRef={tabsRef} />
    </div>
  );
};

export default TabBar;
